<!-- @format -->
<template>
    <div class="modal is-active na-modal-not-found">
        <div class="modal-background na-modal-not-found-background"></div>
        <div class="modal-content na-modal-not-found-content">
            <div class="columns">
                <div class="column">
                    <p class="has-text-centered na-modal-not-found-exclamation">!</p>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <p class="has-text-centered">I'm sorry, there's nothing here.</p>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <p v-if="!reason || reason === 'general'" class="has-text-centered">
                        The section is empty. Try a different one, or adjust your
                        <router-link class="na-link" :to="{ name: 'account', query: { step: 'preferences' } }"
                            >reader settings.</router-link
                        >
                    </p>

                    <p v-if="reason === 'search'" class="has-text-centered">There are no matches for your search.</p>

                    <p v-if="reason === 'directPostNotFound'" class="has-text-centered">Post not available.</p>

                    <p v-if="reason === 'pageNotFound'" class="has-text-centered">That page is not available.</p>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <p class="has-text-centered">But you can always come <a class="na-link" href="/">HOME</a></p>
                </div>
            </div>
        </div>
        <button type="button" class="modal-close is-large" aria-label="close" @click="close"></button>
    </div>
</template>

<script>
export default {
    props: {
        reason: {
            type: String,
            default: 'general'
        }
    },
    methods: {
        /**
         * Close the modal
         */
        close() {
            this.$emit('close');
        }
    }
};
</script>
